module.exports = __webpack_public_path__ + "static/media/traycorp13.634b687f.png";